export default __webpack_public_path__ + "static/media/include_14_male@2x.b9d43292.jpg";